$(document).ready(function () {
  // ---------------------- add to cart drawer -------------------------
  // AJAX cart redirect to checkout
  $(document).on("click", ".ajax-cart-button.shopify", function () {
    var variantID = $(this).attr("data-product-variant-id");
    $(this).closest(".plus-icon").find(".loading-button").addClass("active");
    $(this).addClass("active");
    addToCartJS(1, variantID, $(this));
  });

  function addToCartJS(qty, variantID, btn) {
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var parsedState = JSON.parse(xhr.responseText);
        $(".loading-button").removeClass("active");
        $(".ajax-cart-button").removeClass("active");
        var event = new CustomEvent("cart:build", {
          detail: "Example of an event",
        });

        // Dispatch/Trigger/Fire the event
        document.dispatchEvent(event);

        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
      }
    };
    var data = JSON.stringify({ quantity: qty, id: variantID });
    xhr.send(data);
  }


$(document).on("click", ".ajax-cart-button.boost", function () {
  var $btn = $(this);
  var handle = $btn.attr("data-products-handle");

  // Show loading states
  $btn.closest(".plus-icon").find(".loading-button").addClass("active");
  $btn.addClass("active");

  if (!handle) {
    console.error("Product handle is missing.");
    return;
  }

  // Fetch product data using handle
  fetch(`/products/${handle}.js`)
    .then(res => res.json())
    .then(product => {
      var firstVariantId = product.variants[0]?.id;
      if (!firstVariantId) {
        console.error("No variant found for product:", handle);
        return;
      }

      addToCartJSBoost(1, firstVariantId, $btn);
    })
    .catch(err => {
      console.error("Failed to fetch product data:", err);
    });
});

function addToCartJSBoost(qty, variantID, btn) {
  var xhr = new XMLHttpRequest();
  var url = "/cart/add.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var parsedState = JSON.parse(xhr.responseText);
      $(".loading-button").removeClass("active");
      $(".ajax-cart-button").removeClass("active");

      // Trigger cart update event
      var event = new CustomEvent("cart:build", {
        detail: "Product added to cart",
      });
      document.dispatchEvent(event);

      // Open cart drawer
      var cart = new theme.CartDrawer();
      cart.init();
      cart.open();
    }
  };
  var data = JSON.stringify({ quantity: qty, id: variantID });
  xhr.send(data);
}

  // =================== FAQs section start =================== //
  $(".faq-v2 .has--accordion")
    .first()
    .find(".collapsible-trigger")
    .trigger("click");
  $(document).on("click", ".faq-v2 .collapsible-trigger", function () {
    $(".faq-v2 .collapsible-trigger").removeClass("is-open");
    $(".faq-v2 .collapsible-content").removeClass("is-open").css("height", "0");

    $(this).addClass("is-open");
    var content = $(this).siblings(".collapsible-content");
    var autoHeight = content.get(0).scrollHeight + "px";
    content.addClass("is-open").css("height", autoHeight);
    content.css("height", "auto");
  });

  // =================== FAQs section end =================== //

  // =================== collection list section start =================== //
  function adjustFilterPosition() {
    var collectionFilter = $(".collection-filter");
    var collectionListSection = $(".collection-list-section");

    // Check the length of collectionListSection and conditionally append it
    if ($(window).width() >= 768 && collectionListSection.length) {
      // Move collectionListSection after collectionFilter if not already moved
      if (!collectionFilter.next().is(collectionListSection)) {
        collectionFilter.after(collectionListSection);
      }
    } else if ($(window).width() < 768 && collectionListSection.length) {
      // Revert position for smaller screens (if needed)
      $(".collection-content").before(collectionListSection);
    }
  }

  // Call the function initially and on window resize
  adjustFilterPosition();
  $(window).resize(function () {
    adjustFilterPosition();
  });
  // =================== collection list section end =================== //

  // =================== product page start =================== //
  // Function to format the date with custom weekday and day suffix
  function formatCustomDate(date) {
    const options = { weekday: "long", day: "numeric", month: "long" };
    const parts = new Intl.DateTimeFormat("en-US", options).formatToParts(date);

    const getDaySuffix = (dayNumber) => {
      if (dayNumber % 10 === 1 && dayNumber % 100 !== 11) return "st";
      if (dayNumber % 10 === 2 && dayNumber % 100 !== 12) return "nd";
      if (dayNumber % 10 === 3 && dayNumber % 100 !== 13) return "rd";
      return "th";
    };

    let weekday = "",
      day = "",
      month = "";

    parts.forEach((part) => {
      if (part.type === "weekday") weekday = part.value;
      if (part.type === "day")
        day = `${part.value}${getDaySuffix(+part.value)}`;
      if (part.type === "month") month = part.value;
    });

    return `${weekday}, ${day} ${month}`;
  }

  // Example usage
  $(document).ready(function () {
    const currentDate = new Date();
    const givenDate =
      parseInt($(".countdown-timer .set-date").attr("data-date"), 10) || 0;
    const futureDate = new Date(
      currentDate.setDate(currentDate.getDate() + givenDate)
    );
    $(".countdown-timer .set-date").text(formatCustomDate(futureDate));
  });

  // Set the target date to the end of today
  var targetDate = new Date();
  targetDate.setHours(23, 59, 59, 999); // Set to the last millisecond of today

  // Start the countdown
  var countdownInterval = setInterval(function () {
    var now = new Date().getTime();
    var timeRemaining = targetDate - now;

    // Check if the countdown has ended
    if (timeRemaining <= 0) {
      clearInterval(countdownInterval);
      $("#days").text("0");
      $("#hours").text("0");
      $("#minutes").text("0");
      $("#seconds").text("0");
      return;
    }

    // Calculate remaining hours, minutes, and seconds
    var hours = Math.floor(
      (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    // Display the results
    $("#days").text("0"); // For the rest of today, days will be zero
    $("#hours").text(hours);
    $("#minutes").text(minutes);
    $("#seconds").text(seconds);
  }, 1000);

  // First tab open JS
  $(".product-block--tab")
    .first()
    .find(".collapsible-trigger")
    .trigger("click");

  // review position changes JS
  var productTtile = $(".product-page-right--content .review_content");
  if (productTtile.length > 0) {
    $(".product-page-right--content .product-block--header").before(
      productTtile
    );
  }
  // =================== product page end =================== //

  $(".service-icon-text-slider").slick({
    dots: false,
    arrow: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke_1.png?v=1732266566"></button>`,
          nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke.png?v=1732266566"></button>`,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke_1.png?v=1732266566"></button>`,
          nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke.png?v=1732266566"></button>`,
          infinite: true,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke_1.png?v=1732266566"></button>`,
          nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke.png?v=1732266566"></button>`,
          infinite: true,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $(".logo-bar-slider").slick({
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

// document.addEventListener("DOMContentLoaded", function() {
//   const sliderElement = document.querySelector(".service-icon-text-slider");

//   if (sliderElement) {
//     new Flickity(sliderElement, {
//       cellAlign: "left",        // Align cells to the left
//       contain: true,            // Keep the slider contained
//       wrapAround: true,         // Enable infinite scrolling
//       autoPlay: 3000,           // Auto-play every 3 seconds
//       prevNextButtons: false,   // Hide previous/next buttons
//       pageDots: true,           // Enable page dots
//       draggable: true           // Enable dragging
//     });
//   }
// })


  window.addEventListener('load', function () {
    setTimeout(function () {
      const btn = document.querySelector('button.md-orbe-custom-selector');
      if (btn) {
        btn.style.display = 'flex';
      }
    }, 1500);
  });


  function moveButtonForMobile() {
    const button = document.querySelector('button.md-orbe-custom-selector');
    const mobileNav = document.querySelector('ul.mobile-nav');
    const existingClone = document.querySelector('ul.mobile-nav .md-orbe-custom-selector');

    if (window.innerWidth <= 530) {
      if (button && mobileNav && !existingClone) {
        const buttonClone = button.cloneNode(true);
        const newListItem = document.createElement('li');
        newListItem.classList.add('mobile-nav__item', 'mobile-nav__item--secondary' , 'custom-selector');
        newListItem.appendChild(buttonClone);
        mobileNav.appendChild(newListItem);
        button.style.display = 'none';
      }
    } else {
      // Restore the original button if screen is wider than 530px
      if (button) {
        button.style.display = 'flex';
      }
      // Remove cloned button from mobile nav if it exists
      if (existingClone && existingClone.closest('li.mobile-nav__item')) {
        existingClone.closest('li.mobile-nav__item').remove();
      }
    }
  }

  // Run on load and resize
  window.addEventListener('load', moveButtonForMobile);
  window.addEventListener('resize', moveButtonForMobile);

